export default __webpack_public_path__ + "static/media/cupom-fiscal.69b39378.png";